/**
 * 公用回到顶部组件
 * @author VenDream
 * @since 18/03/23
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import throttle from '@fe/common/lib/throttle';
import './goto-top.less';
import { setTimeout } from 'timers';

/**
 * 回到顶部（动画）
 * @param {HTMLElement} ele      执行动画的DOM节点
 * @param {number}      to       滚动的终点高度
 * @param {number}      duration 动画时长
 */
export function scrollTo(ele, to, duration) {
  const start = ele.scrollTop;
  const change = to - start;
  let currTime = 0;
  const increment = 15;

  // 缓动函数
  Math.easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  // 动画实体
  function animateScroll() {
    currTime += increment;
    const val = Math.easeInOutQuad(currTime, start, change, duration);
    ele.scrollTop = val;

    if (currTime < duration) {
      setTimeout(animateScroll, increment);
    }
  }

  animateScroll();
}

export default class GotoTop extends Component {
  static propTypes = {
    threshold: PropTypes.number,
    duration: PropTypes.number,
    title: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    threshold: 500,
    duration: 500,
  };

  componentDidMount() {
    // 滚动监听
    window.addEventListener('scroll', throttle(this.handleScroll, 100));

    // 获取滚动元素
    this.scroller = document.scrollingElement || document.documentElement;
  }

  componentWillUnmount() {
    // 取消滚动监听
    window.removeEventListener('scroll', throttle(this.handleScroll, 100));
  }

  handleScroll = () => {
    if (this.scroller.scrollTop >= this.props.threshold) {
      this.root && this.root.classList.add('active');
    } else {
      this.root && this.root.classList.remove('active');
    }
  };

  // 回到顶部
  gotoTop = () => {
    scrollTo(this.scroller, 0, this.props.duration);
  };

  render() {
    const { className, title } = this.props;
    return (
      <div
        className={classnames(
          `cmp goto-top transitionable ${className && className}`
        )}
        title="回到顶部"
        onClick={this.gotoTop}
        ref={node => {
          this.root = node;
        }}>
        <i className="s-icon icon-reback" />
        {title && <div className="title">{title}</div>}
      </div>
    );
  }
}
